import gql from "graphql-tag";

export default gql`
  query QueryProjectBySlug($projectSlug: String!) {
    projects(where: { slug: { _eq: $projectSlug } }) {
      id
    }
  }
`;
